import * as yup from 'yup'

export const getAddressNumberValidation = () => yup.string().matches(/^\d*$/, { message: 'Este campo solo acepta números. Para ingresar otros caracteres, use el campo "Complemento".', excludeEmptyString: true }).required()
